export default "__VITE_ASSET__fa47662b__"